
import React, { useMemo } from 'react'

import './ProgressBar.scss'

interface Props {
  value: number
  max: number
  className?: string
}

const ProgressBar = ({ value, max, className }: Props) => {

  const progress = useMemo(() => {

    if (!value || !max) return 0

    return Math.round((value / max) * 100)

  }, [value, max])

  return (
    <div className={`${className || 'progress-bar'}`}>
      <div className='progress-bar-progress' style={{ width: `${progress}%` }}></div>
    </div>
  )
}

export default ProgressBar
